import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerZone } from "../_types/worker-zone";

@Injectable({
    providedIn: 'root',
})
export class WorkerZonesService extends Service<WorkerZone> {
    public override type = 'workerZones';
    public override url = 'providers/workerZones';
}
